import { NgModule } from '@angular/core';
import { NewSidenavComponent } from './new-sidenav.component';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {  MatButtonModule } from '@angular/material/button';
import { HasAccessPipeModule, HasPlansPipeModule, IncludesPipe, IsFeatureFlagEnabledPipeModule, StringIncludesPipe } from '../../pipes';
import { HasServiceCreditPipe } from '../../pipes/has-service-credits.pipe';
import { TooltipIfTruncatedModule } from '../../directives';
import { NavItemComponent } from './components/nav-item.component';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HoverMenuDirective } from './directives/hover-menu.directive';
import { FilterBooleanPipe } from './pipes/filter-boolean.pipe';
import {  MatMenuModule } from '@angular/material/menu';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [
    NewSidenavComponent,
    NavItemComponent,
    HoverMenuDirective,
    FilterBooleanPipe,
  ],
  exports: [NewSidenavComponent],
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    MatButtonModule,
    HasAccessPipeModule,
    HasServiceCreditPipe,
    IsFeatureFlagEnabledPipeModule,
    HasPlansPipeModule,
    MatProgressSpinnerModule,
    IncludesPipe,
    MatMenuModule,
    TooltipIfTruncatedModule,
    MatTooltipModule,
    StringIncludesPipe,
    FontAwesomeModule,
  ],
})
export class NewSidenavModule {}
